<template>
  <section class='how-it-works'>
    <div class="flex-wrapper">
      <div class="content">
        <div class="content-wrap">
          <div class="group">
            <router-link
                class="menu-link"
                :to="{name: 'public.login'}"
            >
              <img :src="logo" alt="Broodje dunner logo">
            </router-link>
          </div>

          <div class="group">
            <h3>Hoe werkt het?</h3>
          </div>

          <p class="light">
            Dit platform is direct gekoppeld aan de webshop van Broodje Dunner. Heb je daar een of meerdere e-books
            aangeschaft? Dan heb je een e-mail ontvangen met inloggegevens. De boeken staan voor je klaar in de Broodje Dunner app.
          </p>

          <p class="light">Kun je de verzonden e-mail niet vinden? Klik dan hieronder op 'Terug naar inloggen' en daarna
            op 'Wachtwoord vergeten'. Dan zorgen we dat je zo snel mogelijk jouw account in kan.</p>

          <StoreButtons />

          <p class="light">Heb je nog geen boeken gekocht, maar wil je dat wel graag? Klik dan hieronder op 'Naar de
            webshop' en rond je bestelling daar af. Je ontvangt daarna een mail met inloggegevens voor de app.</p>

          <a
              class='btn wide'
              target="_blank"
              href="https://broodjedunner.nl"
              style="margin-bottom: 10px"
          >
            Naar de webshop
          </a>

          <router-link
              class='btn wide'
              :to='{name: "public.login"}'
          >
            Terug naar inloggen
          </router-link>
        </div>
      </div>

      <div class="image">
        <img :src="image" alt="Login image for Broodje Dunner">
      </div>
    </div>
  </section>
</template>

<script>
import background from "@/assets/images/login-background.jpeg";
import logo from "@/assets/images/logo.svg";
import StoreButtons from "@/components/blocks/StoreButtons.vue";

export default {
  name: "How it works",
  components: {StoreButtons},
  data() {
    return {
      image: background,
      logo: logo,
    };
  },
};
</script>
